import React from 'react';
import PropTypes from 'prop-types';
import { useHeaderContext } from '@context';
import { getTranslations } from '@translations';
import { PLATFORMS } from '@constants';

import {
  StyledB2BConnectButton,
  StyledB2BConnectLayer,
  StyledB2BConnectPro,
  StyledB2BConnectText,
} from './styled';

export const isVisible = (platform, isAuthenticated, isB2B) =>
  (platform === PLATFORMS.FRANCE.toLowerCase() ||
    platform === PLATFORMS.SPAIN.toLowerCase() ||
    platform === PLATFORMS.ITALY.toLowerCase()) &&
  !(isAuthenticated && isB2B);

const B2BConnect = ({ isAuthenticated, isB2B, platform, className }) => {
  const { platformBaseUrl } = useHeaderContext();

  const isFrance = platform === PLATFORMS.FRANCE.toLowerCase();
  const isSpain = platform === PLATFORMS.SPAIN.toLowerCase();
  const isItaly = platform === PLATFORMS.ITALY.toLowerCase();

  const translations = getTranslations();
  const url = `${translations(
    'header.account.login.url',
  )}?b2b=true&redirect_to_homepage=false`;

  return (
    isVisible(platform, isAuthenticated, isB2B) &&
    (isFrance || isItaly || isSpain) && (
      <StyledB2BConnectLayer className={className}>
        <StyledB2BConnectButton
          tag="a"
          color="secondary"
          href={`/${translations('header.b2c.connect.pro.link')}`}
          data-qa="b2b-signin-button-header-b2c"
          data-url-login={`${platformBaseUrl}${url}`}
          data-gtm-event="click_b2b_login"
          data-gtm-target="header_b2c"
        >
          <StyledB2BConnectPro>
            {translations('header.b2c.connect.pro')}
          </StyledB2BConnectPro>
          <StyledB2BConnectText>
            {translations('header.b2c.connect.text')}
          </StyledB2BConnectText>
        </StyledB2BConnectButton>
      </StyledB2BConnectLayer>
    )
  );
};

B2BConnect.displayName = 'B2BConnect';

B2BConnect.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isB2B: PropTypes.bool.isRequired,
  platform: PropTypes.string.isRequired,
  className: PropTypes.string,
};

B2BConnect.defaultProps = {
  className: null,
};

export default B2BConnect;
